<template>
    <app-data-table :fields="fields" :items="messages" @sort="onSort">
        <template slot="created_at" slot-scope="props">
            {{props.item.created_at | datetime}}
        </template>
        <template slot="actions" slot-scope="props">
            <b-btn v-if="!props.item.detailsShowing" variant="primary" size="sm" @click.stop="props.toggleDetails"><i class="fa fa-search-plus"></i></b-btn>
            <b-btn v-else variant="danger" size="sm" @click.stop="props.toggleDetails"><i class="fa fa-search-plus"></i></b-btn>
        </template>
        <template slot="venues" slot-scope="props">
            <div>
                <ul class="message-venues">
                    <li class="message-venues__item" v-for="venue in props.item.venues" :key="`venue_${venue.id}`">
                        {{venue.name}}
                    </li>
                </ul>
            </div>
        </template>
        <template slot="row-details" slot-scope="props">
            <b-container>
                <b-row>
                    <b-col cols="7">
                        <div class="paper mx-auto" v-html="props.item.description"></div>
                    </b-col>
                    <b-col cols="5">
                        <b-list-group>
                            <b-list-group-item v-for="(file, index) in props.item.client_broadcast_message_files" :key="`file_${index}`" class="d-flex align-items-baseline">
                                <i class="fa" :class="getFileClass(file.name)"></i>
                                <b-btn variant="link">{{file.name}}</b-btn>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-container>
            
        </template>
    </app-data-table>
</template>
<script>
export default {
    name: 'broadcast_message_list',
    props: {
        messages: {
            type: Array,
            default: () => []
        }
    },
    data: () => ({
        fields: [
            {
                key: 'name',
                label: 'Titulo',
                sortable: true
            },
            {
                key: 'venues',
                label: 'Enviado a las sedes',
                sortable: false
            },
            {
                key: 'created_at',
                label: 'Creada el',
                sortable: true
            },
            {
                key: 'actions',
                label: 'Acciones',
                sortable: false
            },
        ]
    }),
    methods: {
        onSort(sortData) {
            this.$emit('sort', sortData);
        },
        getFileClass(name) {
            const index = name.lastIndexOf('.');

            if(-1 === index) return '';

            const ext = name.substr(index + 1);
            const dictionary = {
                pdf: 'fa-file-pdf-o',
                xls: 'fa-file-excel-o',
                xlsx: 'fa-file-excel-o',
                doc: 'fa-file-word-o',
                docx: 'fa-file-word-o',
                jpg: 'fa-file-image-o',
                jpeg: 'fa-file-image-o',
                png: 'fa-file-image-o',
                gif: 'fa-file-image-o',
                txt: 'fa-file-text-o',
                ppt: 'fa-file-powerpoint-o',
                pptx: 'fa-file-powerpoint-o',
            }

            return dictionary[ext] || 'fa-file-o';
        }
    }
}
</script>
<style scoped>
    .message-venues {
        list-style: none;
    }
    .paper {
        border: 1px solid lightgray;
        border-radius: 10px;
        background-color: white;
        max-width: 850px;
        padding: 40px;
    }

    .fa-file-word-o {
        color: #2B5292;
    }

    .fa-file-excel-o {
        color: #348757;
    }

    .fa-file-image-o {
        color: #D42A22;
    }

    .fa-file-pdf-o {
        color: #E73A2F;
    }
</style>